import { render, staticRenderFns } from "./BackCard.vue?vue&type=template&id=4578b1ec&scoped=true&"
import script from "./BackCard.vue?vue&type=script&lang=js&"
export * from "./BackCard.vue?vue&type=script&lang=js&"
import style0 from "./BackCard.vue?vue&type=style&index=0&id=4578b1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578b1ec",
  null
  
)

export default component.exports